import type { ChatEntryData } from "../components/Workflow";

export function serializeChatEntries(
  entries: readonly ChatEntryData[],
  toolOutputs?: Map<string, unknown>
) {
  return entries.map((entry) => ({
    id: entry.id,
    createdAt: entry.createdAt,
    ...(entry.userMessage && {
      role: "user",
      content: entry.userMessage.text,
    }),
    ...(entry.assistantMessage && {
      role: "assistant",
      content: entry.assistantMessage.text,
    }),
    ...(entry.toolCall && {
      role: "tool_call",
      toolName: entry.toolCall.toolName,
      input: entry.toolCall.input,
      output: toolOutputs?.get(entry.id) ?? entry.toolCall.output,
      isError: entry.toolCall.isError,
    }),
    ...(entry.assistantReasoning && {
      role: "reasoning",
      content: entry.assistantReasoning.text,
    }),
    ...(entry.systemMessage && {
      role: "system",
      content: entry.systemMessage.text,
    }),
    ...(entry.userAction && {
      role: "user_action",
      actionType: entry.userAction.actionType,
      userName: entry.userAction.user?.name || entry.userAction.user?.email,
    }),
  }));
}
